import React, { Component }  from "react"

class Content extends Component {
  render() {
    return(
      <div className={`page-content text-xs md:text-sm lg:text-base text-gray-500 leading-loose ${this.props.className}`} dangerouslySetInnerHTML={{__html:this.props.children}}/>
    );
  }
}
export default Content
